// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jh","advertCardPhoto__image":"c-a_ji"};